import { Controller } from '@hotwired/stimulus'

export default class ChangeCalculatorController extends Controller {
  static targets = ['change', 'cashReceived']
  static values = { total: { type: Number, default: 0 } }

  connect = () => {
    this.calculate()
  }

  calculate = () => {
    let change = this.cashReceivedTarget.value - this.totalValue
    if (isNaN(change) || change < 0) { change = 0 }

    this.changeTarget.innerHTML = `$ ${change.toFixed(2)}`
  }
}
